/**
 * Route for `admitad-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AdmitadIntegrationPage } from "../features/admitad-integration/AdmitadIntegrationPage";

export const admitadIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/admitad-integration",
	component: AdmitadIntegrationPage,
});

export default admitadIntegrationRoute;
